import React, { useContext, useState } from 'react';
import { PostData } from './Fetch';
import PlaceOrderResponse from './PlaceOrderResponse';
import { TranslationContext, SettingsContext } from "./Context";
import Select from 'react-select';

function PlaceOrder(props) {

    const translation = useContext(TranslationContext);
    const settings = useContext(SettingsContext);
    const [name, setName] = useState('');
    const [company, setCompany] = useState('');
    const [address, setAddress] = useState('');
    const [customerNumber, setCustomerNumber] = useState('');
    const [city, setCity] = useState('');
    const [zipCode, setZipCode] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [comments, setComments] = useState('');
    const [consent, setConsent] = useState(false);
    const [orderPlaced, setOrderPlaced] = useState(false);
    const formatter = new Intl.NumberFormat(settings.language, { style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2 });

    const createOptions = () => {
        const result = [];
        props.countries.map(x => {

            const option = {};
            option.value = x.Code;
            option.label = x.Name;
            option.icon = <img src={x.FlagUrl} className='heroPartsSearchComponent-dropdownFlag' />
            result.push(option);
        });
        return result;
    };
    const [countryOption, setCountryOption] = useState(createOptions().find(c => c.value === settings.market));

    function handleSubmit(e) {
        e.preventDefault();
        const data = {
            name: name,
            company: company,
            address: address,
            customerNumber: customerNumber,
            city: city,
            zipCode: zipCode,
            country: countryOption.value,
            email: email,
            phone: phone,
            comments: comments,
            consent: consent,
            items: []
        }

        props.items.map(i => {
            const item = {
                articleNumber: i.articleNumber,
                quantity: i.quantity,
            };
            if (i.article && i.article.prices && i.article.prices.length > 0) {
                try {
                    const price = i.article.prices[0].priceCents / 100;
                    const total = price * item.quantity;
                    item.price = `${formatter.format(price)} ${i.article.prices[0].currencyCode}`;
                    item.total = `${formatter.format(total)} ${i.article.prices[0].currencyCode}`;
                } catch (e) {
                    console.error(e);
                }
            }

            data.items.push(item);
        });

        const headers = {
            'X-sc-contextitemid': settings.contextitemid,
            'X-sc-datasourceitemid': settings.datasourceitemid,
            'X-sc-language': settings.language,
            'X-sc-market': settings.market,
            'Content-Type': 'application/json'
        };

        PostData('/order/orderrequest', data, headers)
            .then(data => {
                props.onPlaceOrder(e);
            });
    }

    const formatOptionLabel = ({ value, label, icon }) => (
        <div style={{ display: "" }}>
            {icon}{label}
        </div>
    );

    return (
        <div className="container u-mtop50 u-mbottom50">
            <div className="row">
                <div className="col-xs-12">
                    <h2 className="u-textBold38 text-center u-mbottom30">{translation["TecAlliencePartSearch.PlaceOrder.OrderInformation"]}</h2>
                </div>
            </div>

            <div className="row">
                {orderPlaced && <PlaceOrderResponse />}
                {!orderPlaced &&
                    <form onSubmit={handleSubmit}>


                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="u-textBold14" for="comments">{translation["TecAlliencePartSearch.PlaceOrder.Name"]} *</label>
                                <input className="form-control input-lg" type="text" required onChange={e => setName(e.target.value)} value={name} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="u-textBold14" for="comments">{translation["TecAlliencePartSearch.PlaceOrder.Company"]} *</label>
                                <input className="form-control input-lg" type="text" required onChange={e => setCompany(e.target.value)} value={company} />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="u-textBold14" for="comments">{translation["TecAlliencePartSearch.PlaceOrder.Address"]} *</label>
                                <input className="form-control input-lg" type="text" required onChange={e => setAddress(e.target.value)} value={address} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="u-textBold14" for="comments">{translation["TecAlliencePartSearch.PlaceOrder.CustomerNumber"]} *</label>
                                <input className="form-control input-lg" type="text" required onChange={e => setCustomerNumber(e.target.value)} value={customerNumber} />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="u-textBold14" for="comments">{translation["TecAlliencePartSearch.PlaceOrder.City"]} *</label>
                                <input className="form-control input-lg" type="text" required onChange={e => setCity(e.target.value)} value={city} />
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="u-textBold14" for="comments">{translation["TecAlliencePartSearch.PlaceOrder.ZipCode"]} *</label>
                                        <input className="form-control input-lg" type="text" required onChange={e => setZipCode(e.target.value)} value={zipCode} />
                                    </div>
                                </div>

                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label className="u-textBold14" for="comments">{translation["TecAlliencePartSearch.PlaceOrder.Country"]} *</label>
                                        <Select id='country' options={createOptions()} value={countryOption} required="required"
                                            onChange={(e) => setCountryOption(e)} formatOptionLabel={formatOptionLabel} />
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="u-textBold14" for="comments">{translation["TecAlliencePartSearch.PlaceOrder.Email"]} *</label>
                                <input className="form-control input-lg" type="email" required onChange={e => setEmail(e.target.value)} value={email} />
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="form-group">
                                <label className="u-textBold14" for="comments">{translation["TecAlliencePartSearch.PlaceOrder.Phone"]} *</label>
                                <input className="form-control input-lg" type="text" required onChange={e => setPhone(e.target.value)} value={phone} />
                            </div>
                        </div>

                        <div className="col-xs-12">
                            <div className="form-group">
                                <label className="u-textBold14" for="comments">{translation["TecAlliencePartSearch.PlaceOrder.Comments"]}</label>
                                <textarea className="form-control input-lg" id="comments" rows="5" onChange={e => setComments(e.target.value)} value={comments}></textarea>
                            </div>
                        </div>

                        <div className="col-xs-12">
                            <div className="small text-muted u-mbottom20">{translation["TecAlliencePartSearch.PlaceOrder.OrderExtraInformation"]}</div>

                            <div className="custom-form">
                                <div className="custom-form-cbxWrap">
                                    <input className="custom-form-checkbox" type="checkbox" required="required" id="{1B57487A-BFFF-4D49-9520-41A64792F735}" name="{1B57487A-BFFF-4D49-9520-41A64792F735}" onChange={e => setConsent(e.target.checked)} checked={consent} />
                                    <label className="custom-form-checkboxLabel u-textRegular16" for="{1B57487A-BFFF-4D49-9520-41A64792F735}">{translation["TecAlliencePartSearch.PlaceOrder.IAgreeToTheTermsAndConditions"]} *</label>

                                </div>
                            </div>
                            <div className="text-center">
                                <button type="submit" className="btn btn-primary u-xsBlock">{translation["TecAlliencePartSearch.PlaceOrder.SendOrderRequest"]}</button>
                            </div>

                        </div>
                    </form>
                }
            </div>


        </div>

    );

}

export default PlaceOrder;